import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    /*
    var alturaFooter = (document.getElementById('footer').offsetHeight) - 32;
    console.log(alturaFooter);
    document.getElementById('footer').style.bottom  = alturaFooter + 'px';
    console.log(document.getElementById('footer').style.bottom  = alturaFooter + 'px');
    */
  }

}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/footer/footer.component.ts